<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .builder-domain-label {
    @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
  }

  .builder-link {
    color: $salesflow-font-gray;
  }

  .builder-label {
    @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
  }


  .page-not-published {
    color: $salesflow-outline-gray-medium;
  }

  .lock-icon {
    position: relative;
    top: -2px;
  }

  .builder-header {
    width: 100%;
    background-color: $gray-mako;
    padding: 0 20px;
    border-radius: 15px 15px 0 0;

    .btn {
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 1.42857;
      border: 1px solid transparent;
      white-space: nowrap;
      touch-action: manipulation;
    }

    .btn-bee {
      min-width: 100px;
      color: $white;
      background-color: #4cb9ea;
      border-color: #35b0e7;
      margin: 12px 0;
      padding: 6px 12px;
      border-radius: 5px;
      text-transform: uppercase;

      &:hover {
        background-color: #1ea7e5;
        border-color: #1791c8;
      }
    }

    &-label {
      color: $white;
      line-height: 25px;
    }
  }

  .builder-content {
    height: calc(100vh - 250px);
  }
</style>

<template>
  <section class="page-builder">
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <h2
          class="page-subtitle"
          :key="key.title"
        >
          {{ page.title || __('LP sem título') }}
        </h2>
        <div v-if="page" :class="pageDomainClass" class="ml-auto pt-5px builder-domain-label">
          <IconClosedLock
            class="lock-icon"
            :size="16"
            v-if="page.isDomainCertified"
            :color="pageDomainColor"
          />
          <IconOpenLock
            class="lock-icon"
            :size="16"
            v-else
            :color="pageDomainColor"
          />
          <span class="ml-1">
            {{ page.isDomainCertified ? __('Ativo') : __('Inativo') }}
          </span>
        </div>

        <a
          class="builder-link ml-4 pt-5px"
          target="_blank"
          :href="page.public_url"
          :key="key.public_url"
        >
          <IconEye
            color="#71767D"
          /><span class="builder-label ml-2">{{ __('Visualizar') }}</span></a><a
          class="builder-link ml-4 pt-5px"
          href="#"
          @click.prevent="clone()"
        >
          <IconCopy
            color="#71767D"
            :size="18"
          /><span class="builder-label ml-2">{{ __('Clonar') }}</span></a>

        <a
          class="builder-link ml-4 pt-5px"
          href="#"
          @click.prevent="openPageSetup()"
        >
          <IconCog :size="19" /><span class="builder-label ml-2">{{ __('Configurações') }}</span></a>
        <PageSetup
          class="ml-4"
          :page="page"
        /><span class="builder-label ml-2">{{ __('Publicar') }}</span>
      </div>
    </div>
    <div
      class="builder mt-4"
      id="builder"
    >
      <div class="builder-header d-flex d-align-items-center">
        <IconFrame
          class="mt-2 pr-2"
          :size="39"
        />
        <PageEditable
          class="px-25px py-15px"
          :theme="page.theme"
          :css="page.custom_css"
          :url="'/page/' + page.id"
          :value="page.editable"
          label="label"
        >
          <span class="builder-header-label">{{ __('Estilo') }}</span>
        </PageEditable>
        <button
          class="btn btn-bee ml-auto"
          type="button"
          @click="save()"
          :disabled="saving"
        >
          <span v-if="saving">{{ __('Salvando...') }}</span><span v-else>{{ __('Salvar') }}</span>
        </button>
      </div>
      <div class="builder-content">
        <iframe
          id="builder-iframe"
          ref="iframe"
          frameBorder="0"
          style="height: 100%; width: 100%;"
          :src="builder.src"
          @load="iframeLoaded()"
          seamless="seamless"
          v-if="builder.iframe"
        />
        <div
          id="builder-content"
          v-else
        />
      </div>
    </div>
  </section>
</template>

<script>
import { Confirm } from '../../services/Confirm';

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
    builder: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      widgets: {
        form: '{form:(.*?)}',
      },
      key: {
        title: this.page.title,
        public_url: this.public_url,
      },
      forms: [],
      inserted: {
        form: [],
      },
      pageDomainColor: '#71767D',
      pageDomainClass: 'page-published',
      search: '',
      searching: false,
      saving: false,
    };
  },

  computed: {
    formsNotInserted () {
      return this.forms.filter((form) => this.filterNotInserted('form', form));
    },
  },

  created () {
    window.onbeforeunload = () => 'Descartar alterações e sair?';

    Bus.$on('pageUpdated', (page) => this.updatePage(page));

    // Reload after style/css update
    Bus.$on('styleUpdated', (alert) => this.reload());

    this.updateDomainStatus();
  },

  methods: {
    load (data) {
      this.$http.get('/form')
        .then((response) => {
          this.forms = response.data;

          this.verifyInserted();
        });
    },

    reload () {
      window.onbeforeunload = function () {};
      window.location.reload();
    },

    async clone () {
      if (! await Confirm(this.__('Deseja clonar esta landing page? A landing page clonada irá abrir em uma nova janela.'))) {
        return;
      }

      this.$http.post(`/page/${this.page.id}/clone`)
        .then(({ data }) => window.open(`/page/${data.id}`))
        .catch((error) => console.warn(error));
    },

    openPageSetup () {
      Bus.$emit('openPageSetup');
    },

    updatePage (page) {
      this.page.slug = page.slug;
      this.page.title = page.title;
      this.page.domain = page.domain;
      this.page.published = page.published;
      this.page.public_url = page.public_url;
      this.page.meta_description = page.meta_description;

      this.key.title = page.title;
      this.key.public_url = page.public_url;

      this.updateDomainStatus();
    },

    updateDomainStatus () {
      if (!this.page || !this.page.published) {
        this.pageDomainClass = 'page-not-published';
        this.pageDomainColor = '#D1D1D1'
        return;
      }

      this.pageDomainClass = 'page-published';
      this.pageDomainColor = this.page.isDomainCertified ? '#12BA7F' : '#CC0025';
    },

    iframeLoaded () {
      const self = this;
      const iframe = document.querySelector('#builder-iframe');
      const contents = iframe.contentDocument || iframe.contentWindow.document;

      // Verify widgets inserted
      this.verifyInserted();

      contents.keyup(() => {
        if (window.eraseContentDebounce) {
          window.clearTimeout(window.eraseContentDebounce);
        }

        window.eraseContentDebounce = window.setTimeout(() => {
          self.verifyInserted();
        }, 600);
      });

      // Height fix
      const calcHeight = function () {
        if (window.builderResizeDebounce) {
          window.clearTimeout(window.builderResizeDebounce);
        }

        window.setTimeout(() => {
          const framePageHeight = contents.innerHeight();
          const thisPageHeight = window.innerHeight;

          document.querySelector('.builder-content').style.height = thisPageHeight - 54;

          iframe.setAttribute('height', framePageHeight);
        }, 500);
      };

      window.addEventListener('resize', () => {
        calcHeight();
      });

      calcHeight();

      contents.on('click', () => {
        Bus.$emit('onThemeClick');
      });
    },

    changeWidgetStyle (element, style) {
      style = style || 'block';
      switch (style) {
        case 'block':
          element.style.color = '#333';
          element.style.display = 'inline-block';
          element.style.border = '1px dashed #333';
          element.style.padding = '8px 13px';
          element.style.color = '#EEE';
          break;
        case 'inline':
          element.style.display = 'inline';
          element.style.border = '1px dashed #DDD';
          element.style.backgroundColor = '#EEE';
      }
    },

    // doSearch: function (search) {
    //   this.searching = true;
    //   this.forms = [];

    //   this.$http.get('/form/search', {q: search}, function (data) {
    //     this.forms = data;
    //     this.searching = false;
    //     this.verifyInserted();
    //   });
    // },

    verifyInserted () {
      const self = this;

      // Clean inserted elements array
      for (const i in this.inserted) {
        this.inserted[i] = [];
      }

      // Insert id of inserted elements in inserted elements array
      $('#builder-iframe').contents().find('[data-pattern]').each(function () {
        const object = self.getPatternObject($(this).attr('data-pattern'));

        if (! object) {
          return;
        }

        // Push into inserted list
        for (const i in object) {
          if (self.inserted[i]) {
            self.inserted[i].push(`${object[i]}`);
          }
        }
      });
    },

    // Transform pattern into object
    getPatternObject (str) {
      for (const i in this.widgets) {
        const regex = new RegExp(this.widgets[i]);

        if (regex.test(str)) {
          const object = {};
          object[i] = (`${regex.exec(str)[1]}`).trim();
          return object;
        }
      }
    },

    filterNotInserted (type, obj) {
      return this.inserted[type].indexOf(`${obj.id}`) === -1;
    },

    saveAndReload () {
      return this.save(false, true);
    },

    save (emit = false, reload = false) {
      const slots = [];

      $('.section-editable', $('#builder-iframe').contents()).each(function () {
        const section = $(this).clone();

        section.find('[data-pattern]').each(function () {
          const pattern = $(this).attr('data-pattern');

          $(this).replaceWith(pattern);
        });

        section.find('[data-original-variable]').each(function () {
          const pattern = $(this).attr('data-original-variable');

          $(this).replaceWith(pattern);
        });

        section.find('[data-replaceable]').each(function () {
          const pattern = $(this).attr('data-replaceable');

          $(this).parent().append(pattern);
          $(this).remove();
        });

        section.find('[data-mce-object="iframe"]').each(function () {
          jQuery(this).find('iframe').addClass('embed-responsive-item');
          jQuery(jQuery(this).html()).insertBefore(jQuery(this).parent());
          jQuery(this).parent().remove();
        });

        if (section.html() !== '') {
          slots.push({
            name: section.attr('name').replace('slot-', ''),
            content: section.html(),
          });
        }
      });

      this.saving = true;

      this.$http.put(`/page/${this.page.id}`, { slots })
        .then((response) => {
          Alert.info(this.__('Conteúdo salvo'));

          if (reload) {
            this.reload();
          }
        })
        .catch((response) => {
          Alert.error(this.__('Erro ao salvar conteúdo, tente novamente mais tarde.'));
        })
        .finally((response) => {
          this.saving = false;
        });
    },
  },
};
</script>
